"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useControlledForm = exports.useForm = void 0;

var react_1 = __importDefault(require("react"));

var react_hook_form_1 = require("react-hook-form");

var isNative_1 = require("../isNative");

function useForm() {
  return (0, react_hook_form_1.useForm)({
    mode: isNative_1.isNative ? 'onChange' : undefined
  });
}

exports.useForm = useForm;

function useControlledForm(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  var form = useForm();
  react_1.default.useEffect(function () {
    form.reset(value);
  }, [JSON.stringify(value)]);
  var allValues = form.watch();
  react_1.default.useEffect(function () {
    form.trigger().then(function (result) {
      if (result) {
        onChange(Object.assign(Object.assign({}, value), allValues));
      }
    });
  }, [JSON.stringify(allValues)]);
  return form;
}

exports.useControlledForm = useControlledForm;